<template>
  <div class="card shadow-sm p-3 mb-3 pb-4">
    <div class="row">
      <div class="col-md-2">
        <label class="form-label small">Start Date</label>
        <input
          v-model="localFilters.date_from"
          type="date"
          class="form-control form-control-sm"
        />
      </div>

      <div class="col-md-2">
        <label class="form-label small">End Date</label>
        <input
          v-model="localFilters.date_to"
          type="date"
          class="form-control form-control-sm"
        />
      </div>

      <div class="col-md-2">
        <label class="form-label small">Device</label>
        <select
          v-model="localFilters.device_id"
          class="form-select form-select-sm"
        >
          <option value="">All Devices</option>
          <option v-for="device in devices" :key="device.id" :value="device.id">
            {{ device.name ?? `Device #${device.id}` }}
          </option>
        </select>
      </div>

      <div class="col-md-4 d-flex align-items-end gap-2 mt-3">
        <button
          class="btn btn-primary btn-sm px-4"
          @click="$emit('apply', localFilters)"
        >
          Apply
        </button>
        <button
          class="btn btn-outline-secondary btn-sm px-4 ms-2"
          @click="$emit('export', localFilters)"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClosedDaysFilters",
  props: {
    filters: {
      type: Object,
      required: true,
    },
    devices: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localFilters: {
        device_id: this.filters.device_id ?? "",
        date_from: this.filters.date_from ?? null,
        date_to: this.filters.date_to ?? null,
      },
    };
  },
  computed: {
    filterableColumns() {
      return this.columns.filter((col) => col.filterable !== false);
    },
  },
};
</script>
